import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import ChapterType from '../entities/chapterType'
import Cascader from '../entities/cascader'
import Ajax from '@/lib/ajax'
import PageResult from '@/store/entities/page-result';


interface ChapterTypeState extends ListState<ChapterType> {
    editChapterType: ChapterType;
    cascaders: any;
}
class ChapterTypeModule extends ListModule<ChapterTypeState, any, ChapterType>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ChapterType>(),
        loading: false,
        editChapterType: new ChapterType(),
        cascaders: new Array<Cascader>(),
    }
    actions = {
        async getAll(context: ActionContext<ChapterTypeState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ChapterType/GetAll', { params: payload.data });
            context.state.loading = false;   
            let page = reponse.data.result as PageResult<ChapterType>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },        
        async create(context: ActionContext<ChapterTypeState, any>, payload: any) {
            await Ajax.post('/api/services/app/ChapterType/Create', payload.data);
        },
        async update(context: ActionContext<ChapterTypeState, any>, payload: any) {
            await Ajax.put('/api/services/app/ChapterType/Update', payload.data);
        },
        async delete(context: ActionContext<ChapterTypeState, any>, payload: any) {
            await Ajax.delete('/api/services/app/ChapterType/Delete?Id=' + payload.data.id);
        },
        async get(context: ActionContext<ChapterTypeState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/ChapterType/Get?Id=' + payload.id);
            return reponse.data.result as ChapterType;
        },
        async getCascader(context: ActionContext<ChapterTypeState, any>, payload: any) {            
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ChapterType/GetCascaderList', { params: payload.data });
            context.state.cascaders = reponse.data.result as Array<Cascader>;
        },
        
    };
    mutations = {
        setCurrentPage(state: ChapterTypeState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ChapterTypeState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: ChapterTypeState, chapterType: ChapterType) {
            state.editChapterType = chapterType;
        }
    }
}
const chapterTypeModule = new ChapterTypeModule();
export default chapterTypeModule;